import g from "./vue-editor2.js";
import { LoggerService as s, Constants as l, ContentRendererService as y } from "@magnolia/frontend-helpers-base";
import { isProxy as M, toRaw as _, h as C } from "vue";
const f = (e, r, n, p, i, m) => {
  if (!e)
    return s.error("Component content is null or undefined"), null;
  if (!e[l.TEMPLATE_ID_PROP])
    return s.error("Component content is missing"), null;
  if (!n)
    return s.error("Component mappings is null or undefined"), null;
  let o = n[e[l.TEMPLATE_ID_PROP]] || null, u = !1;
  if (!o) {
    const t = `Component with ID ${e[l.TEMPLATE_ID_PROP]} is not mapped.`;
    s.error(t);
    const c = d(p);
    if (!c)
      return null;
    o = c, u = !0;
  }
  const P = y.buildComponentProperties(
    e,
    r,
    m,
    u
  ), a = M(o) ? _(o) : o;
  return C(a, P, i);
};
function d(e) {
  let r = null;
  return typeof e == "function" ? r = e() : r = e, typeof r == "boolean" && r && (r = g), typeof e == "object" && (r = e), r;
}
const R = (e, r, n, p, i, m = 0) => f(
  e,
  r,
  n,
  p,
  i,
  m
), L = {
  mgnlRender: R,
  getRenderedComponent: f,
  getFallbackComponent: d
};
export {
  L as default
};
//# sourceMappingURL=vue-editor7.js.map
